import { subscript } from "./subscript";

export function minifyDecimals(number: string | number, decimals = 3) {
  number = +number;
  if (number !== 0 && number < Number(`1e-${decimals}`)) {
    const str = number.toExponential(decimals - 1);
    const remains = str.replace(/(\.|e-\d+$)/gi, "").replace(/0+$/, "");
    const zeros = Number(str.split("e-")[1]);
    return "0.0" + subscript(zeros - 1) + remains;
  }
  number = +(+number).toFixed(decimals);
  return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}
